import { API } from 'aws-amplify';
import { IUserData } from './interfaces';

interface IPostEventData {
    name : string,
    distanceMeters: number,
    activityType : "Run" | "TrailRun",
    terrain: "Flat",
    estimatedDurationMinutes : number
}

function _postEvent(data: IPostEventData) {
    const apiName = 'api1';
    const path = '/event';
    const myInit = {
      //headers: {} // OPTIONAL
      body: {
       ...data
      }
    };
    return API.post(apiName, path , myInit);
  }
  
export async function postEvent(data : IPostEventData) {

    // hack to force a salt array while we update the backend to return one, can be removed once back end returning an array.
    // const res = await _postEvent(data);
    // if (res.data) {
    //   const salt = res.data?.products?.salt;
    //   if (!Array.isArray(salt)) {
    //     res.data.products.salt = [res.data?.products?.salt]
    //   }
    // }
    return await _postEvent(data);
};

function _postUserData(data: IPostUserData) {
  const apiName = 'api1';
    const path = '/user';
    const myInit = {
      //headers: {} // OPTIONAL
      body: {
       ...data 
      } 
    };  
    return API.post(apiName, path , myInit);
}

export type IPostUserData = Omit<IUserData, "ID" | "email">

export async function postUserData(data : IPostUserData) {
  const res =  await _postUserData(data);
  return res as { data : IUserData}
};

function _getUserData() {
  const apiName = 'api1';
  const path = '/user';
  return API.get(apiName, path, {});
}

export async function getUserData() {
  const res = await _getUserData();
  return res as IUserData
};


  
